:host {
  display: block;
  max-width: 100%;
  overflow: hidden;
}

.wrapper {
  padding: 0 0 0 calc(var(--spacer) * 2);
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
}

.section {
  height: auto;
  padding-bottom: var(--spacer);
  margin-bottom: var(--spacer);

  &:not(:last-child) {
    border-bottom: 1px solid var(--chart-101-pressed-dividers);
  }
}

.footer {
  height: 52px;
  display: flex;
  align-items: center;
}

.nav-buttons {
  position: absolute;
  right: calc(2 * var(--spacer) + 24px);
  top: calc(2 * var(--spacer));
  z-index: 1050;
  height: auto;
}
